import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {environment} from '~/environments/environment';

@Component({
    selector: 'app-city-map',
    templateUrl: './city-map.component.html',
    styleUrls: ['./city-map.component.scss']
})
export class CityMapComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    apiUrl = environment.apiUrl;
    url = '';

    constructor() {
    }

    ngOnInit() {
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
    }

    setData() {
        this.url = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyDXc1wdanaF5CrjTxF0s2Pd9B5EAhi6YY8&zoom=8&q=' + this.favorite.ad_city.zip_code + ' ' + this.favorite.ad_city.name;
    }
}
